'use strict';

/**
 * Sample Element Service
 */
module.service('sampleElementService', [ 'Restangular', '$q', function(Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
    var sampleElementResource = Restangular.all('sampleelement');

    return {

        searchSamplesElements : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            sampleElementResource.customGET('', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        searchAll : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            sampleElementResource.customGET('all', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        createSampleElement : function(SampleElement) {
            var deferred = $q.defer();
            var answer = new restResponse();

            sampleElementResource.post(SampleElement).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },

        loadSampleElement : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            sampleElementResource.get(id).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        updateSampleElement : function(id, sampleElement) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('sampleelement', id).customPUT(sampleElement).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        deleteSampleElement : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('sampleelement', id).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

    };
} ]);